module.exports = __webpack_public_path__ + "img/[拳头].805cbfdf.svg";